import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createstationGroups(data) {
    let response = await apiCall("fuel_station_groups/create", data);
    return response;
  },
  async list_stations_groups(data) {
    let response = await apiCall(
      "fuel_station_groups/list_fuel_station_groups",
      data
    );
    return response;
  },

  async update_stations_groups(data) {
    let response = await apiCall(
      "fuel_station_groups/update_fuel_station_group",
      data
    );
    return response;
  },
};
